enum PersistenceHint {
  Persistent = 'Persistent',
  Ephemeral = 'Ephemeral'
}

export default PersistenceHint;
